<form class="filter" [formGroup]="paymentsReconFilterForm" (submit)="applyFilters()">
    <modal-panel
        data-testid="adx-payment-filter-modal-panel"
        class="adx-payment-filter-modal-panel-cls filter-panel"
        [title]="'Filter'"
        (close)="closeModal();"
        >
            <div data-testid="adx-payment-filter-modal-div-2" class="filter__fields">
                <mat-grid-list class="modal-filter-col-flex" [cols]="isSmall ? 1 : 2" gutterSize="10px" rowHeight="85">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <mat-select formControlName="reconType">
                                <mat-option value="I">Client</mat-option>
                                <mat-option value="V">Vendor</mat-option>
                            </mat-select>
                            @if(paymentsReconFilterForm.controls['reconType'].value){
                                <button 
                                    data-testid="pay-method-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearFields('reconType'); $event.stopPropagation()">
                                        <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Processor</mat-label>
                            <mat-select formControlName="processorIds" multiple>
                                <mat-option [value]="1">Connexpay</mat-option>
                                <mat-option [value]="2">Braintree</mat-option>
                            </mat-select>
                            @if(paymentsReconFilterForm.controls['processorIds'].value){
                                <button 
                                    data-testid="pay-method-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearFields('processorIds'); $event.stopPropagation()">
                                        <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <dynamic-autocomplete
                            formControlName="adxReference"
                            [formLabel]="'Trip Record Locator'"
                            [tableName]="'Trip'"
                            [columnName]="'ExternalReference'"
                            [emitString]="true"
                            [dataTestId]="'adx-reference-autocomplete'">
                        </dynamic-autocomplete>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <dynamic-autocomplete
                            formControlName="lastFourCC"
                            [formLabel]="'Card Last Four'"
                            [tableName]="'AdxPayment'"
                            [columnName]="'LastFourCC'"
                            [emitString]="true"
                            [maxResults]="4"
                            [dataTestId]="'last-four-cc-autocomplete'">
                        </dynamic-autocomplete>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Release Date From</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="releaseDateFrom">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            @if(paymentsReconFilterForm.controls['releaseDateFrom'].value){
                                <button 
                                    data-testid="adx-payment-date-from-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearFields('releaseDateFrom')">
                                        <mat-icon>close</mat-icon>
                                </button>
                            } @else {
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                            }
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Release Date To</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="releaseDateTo">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            @if(paymentsReconFilterForm.controls['releaseDateTo'].value){
                                <button 
                                    data-testid="adx-payment-date-from-clear-filter-button"
                                    matSuffix mat-icon-button
                                    type="button"
                                    (click)="clearFields('releaseDateTo')">
                                        <mat-icon>close</mat-icon>
                                </button>
                            } @else {
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                            }
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list class="modal-filter-col-flex" [cols]="1" gutterSize="10px" rowHeight="85">
                    <mat-grid-tile>
                        <div style="width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px;">
                            <p style="margin: 0; font-size: 14px; flex: 0 0 auto; min-width: 80px;">Matched</p>
                            <div style="display: flex; justify-content: center; align-items: center; flex: 1;">
                                <mat-radio-group formControlName="isMatched" aria-label="matching-mode" [color]="'primary'" style="display: flex; gap: 24px;">
                                    <mat-radio-button [value]="true" style="margin: 0;">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false" style="margin: 0;">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <button
                                data-testid="matching-is-mapped-clear-filter-button"
                                mat-icon-button
                                type="button"
                                style="flex: 0 0 auto;"
                                (click)="clearFields('isMatched')"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
            <ng-container data-testid="adx-payment-modal-footer-container" modalPanelFooter>
                <div class="modal-footer">
                    <button data-testid="adx-payment-filter-modal-button-clear-all" mat-stroked-button color="primary" type="button" (click)="clearFields()">
                        <mat-icon data-testid="adx-payment-filter-clear-all-filter-button-icon">delete_outline</mat-icon>
                        Clear All
                    </button>
                    <button data-testid="adx-payment-modal-button" mat-raised-button color="primary" type="submit" [disabled]="paymentsReconFilterForm.invalid">Apply</button>
                </div>
            </ng-container>
    </modal-panel>
</form>